import Navbar from '../components/Navbar';
import VesselTabs from '../components/Manuevers/VesselTabs';
import OrbitDisplayTabs from '../components/Manuevers/OrbitDisplayTabs';
import FlightPlanInfoTabs from '../components/Manuevers/FlightPlanInfoTabs';
import HelpCollapse from '../components/Manuevers/HelpCollapse';
import DashboardPanel from '../components/DashboardPanel';

import React, {useEffect, useState, useRef } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';

import { useAtom } from 'jotai';
import { systemAtom, flightPlansAtom, vesselPlansAtom } from '../App';
import Kepler from '../main/libs/kepler';


// worker
const propagateWorker = new Worker(new URL("../workers/propagate.worker.ts", import.meta.url));

////////// App Content //////////
function ManeuversAppContent() { 
  const [vesselPlans] = useAtom(vesselPlansAtom);
  const vesselPlansRef = useRef<IVessel[]>(vesselPlans);

  const [system] = useAtom(systemAtom);
  const [, setFlightPlans] = useAtom(flightPlansAtom);

  const [showHelp, setShowHelp] = useState(false);

  // UI State
  const [leftOpen, setLeftOpen] = useState(true);
  const [rightOpen, setRightOpen] = useState(true);

useEffect(() => {
  propagateWorker
    .postMessage({vesselPlans, system});
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [])

useEffect(() => {
  propagateWorker.onmessage = (event: MessageEvent<FlightPlan[]>) => {
    if (event && event.data) {
      setFlightPlans(event.data);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [propagateWorker]);

useEffect(() => {
if(!Kepler.vesselListsAreEqual(vesselPlansRef.current, vesselPlans)) {
    vesselPlansRef.current = vesselPlans;
    propagateWorker
    .postMessage({vesselPlans, system});
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [vesselPlans, system]);


  ///// App Body /////
  return (
    <div style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden' }}>
      <CssBaseline />
      
      {/* Background Layer: 3D Orbit Display */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
        <OrbitDisplayTabs />
      </div>

      {/* UI Overlay Layer */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1, pointerEvents: 'none', display: 'flex', flexDirection: 'column' }}>
        <Navbar showHelp={showHelp} setShowHelp={setShowHelp} />
        
        {/* Floating Header */}
        <div style={{ margin: '16px 32px', pointerEvents: 'auto' }}>
          <Typography variant="h4" color="primary" sx={{ fontWeight: 800, textShadow: '0 0 10px rgba(0, 243, 255, 0.5)' }}>
            FLIGHT PLANNER
          </Typography>
          <HelpCollapse showHelp={showHelp} />
        </div>

        {/* Dashboard Panels */}
        <DashboardPanel 
          side="left" 
          title="Fleet Operations" 
          isOpen={leftOpen} 
          onToggle={() => setLeftOpen(!leftOpen)}
          width={380}
        >
          <VesselTabs />
        </DashboardPanel>

        <DashboardPanel 
          side="right" 
          title="Flight Telemetry" 
          isOpen={rightOpen} 
          onToggle={() => setRightOpen(!rightOpen)}
          width={420}
        >
          <FlightPlanInfoTabs />
        </DashboardPanel>
      </div>
    </div>
  )
}

function ManeuversApp() {
  return <>{ManeuversAppContent()}</>
}

export default React.memo(ManeuversApp);
